export default __webpack_public_path__ + "images/825e31a53b862e1843a7c47af305a74d.svg";